import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, normalizeProps as _normalizeProps, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "prod-offers__top" };
const _hoisted_2 = { class: "prod-offers__switch" };
const _hoisted_3 = { class: "prod-offers__main" };
const _hoisted_4 = {
    key: 1,
    class: "prod-offers__main"
};
import { inject, ref, watch } from "vue";
import LegacyOfferList from "./components/LegacyOfferList.vue";
import OfferSelector from "../components/OfferSelector.vue";
import Toggle from "../../../components/Toggle.vue";
import cookies from "js-cookie";
import PreOrder from "../components/PreOrder.vue";
import DeliveryInfo from "./components/DeliveryInfo.vue";
import NoDiscountInfo from "./components/NoDiscountInfo.vue";
import Coupon from "../../../components/Coupon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductCardApp',
    props: {
        coupon: { type: Object },
        product: { type: Object, required: true },
        types: { type: Array, required: true },
        delivery: { type: Object, required: true },
        newInterface: { type: Boolean },
    },
    setup(__props) {
        const props = __props;
        const newInterface = ref(props.newInterface);
        const available = !!props.product.offers.find(offer => offer.active);
        const type = inject('type');
        watch(newInterface, value => {
            cookies.set('legacy_offer_list_view', JSON.stringify(!value), { expires: 365 });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(Toggle, {
                            label: "Новый вид подбора товаров",
                            modelValue: newInterface.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((newInterface).value = $event))
                        }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    (__props.coupon)
                        ? (_openBlock(), _createBlock(Coupon, {
                            key: 0,
                            coupon: __props.coupon,
                            "brand-name": __props.product.brandName
                        }, null, 8 /* PROPS */, ["coupon", "brand-name"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                available
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_3, [
                            (newInterface.value)
                                ? (_openBlock(), _createBlock(OfferSelector, {
                                    key: 0,
                                    types: __props.types,
                                    product: __props.product
                                }, null, 8 /* PROPS */, ["types", "product"]))
                                : (_openBlock(), _createBlock(LegacyOfferList, {
                                    key: 1,
                                    product: __props.product,
                                    types: __props.types
                                }, null, 8 /* PROPS */, ["product", "types"]))
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (!__props.product.sale)
                            ? (_openBlock(), _createBlock(NoDiscountInfo, {
                                key: 0,
                                id: __props.product.id
                            }, null, 8 /* PROPS */, ["id"]))
                            : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(PreOrder, {
                            "product-id": __props.product.id,
                            available: available
                        }, null, 8 /* PROPS */, ["product-id"])
                    ])),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (available && !_unref(type)?.disabled)
                    ? (_openBlock(), _createBlock(DeliveryInfo, _normalizeProps(_mergeProps({ key: 2 }, __props.delivery)), null, 16 /* FULL_PROPS */))
                    : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
